import PlacesAutocomplete from "../autocomplete/PlacesAutocomplete";

import { findGoogleAddressStringDetails } from "../../../helpers/utils/geography";

const normalizeDestinationForAutocomplete = (destination) => {
  if (!destination) {
    return null;
  }
  if (destination.description) {
    return destination;
  }
  const scoutDescription =
    destination.address ||
    destination.name ||
    [destination.city, destination.country].filter(Boolean).join(", ");
  return scoutDescription
    ? { ...destination, description: scoutDescription }
    : null;
};

const ProductsPlacesAutocomplete = ({
  destination,
  editDestination,
  label,
  disabled
}) => {
  const editPlace = async (place) => {
    if (!place || !place.description) {
      return editDestination({});
    }

    const { place_id: placeId, description } = place;
    const address = await findGoogleAddressStringDetails(placeId);
    return editDestination({ ...address, description });
  };

  return (
    <PlacesAutocomplete
      label={label}
      place={normalizeDestinationForAutocomplete(destination)}
      editPlace={editPlace}
      disabled={disabled}
    />
  );
};
export default ProductsPlacesAutocomplete;
